import React from 'react';
import { SHELL_WHITE } from '../../theme/colors';
import { T } from '../../theme/typography';
import Button from '../shared/Button';
import { useIsMobile } from '../../hooks/useIsMobile';

// Reuses the same gradient background as the actual SignUp screen on
// app.vesna.health, so this mid-page teaser visually rhymes with where it
// hands off to — a deliberate echo, not a coincidence.
const CTABanner = ({ eyebrow, heading, onGetStarted }) => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: SHELL_WHITE,
        backgroundImage: 'url(/state-assets/backgrounds/main-bg.svg)',
        backgroundSize: 'cover',
        backgroundPosition: '50%',
        padding: isMobile ? '64px 20px' : '96px 64px',
      }}
    >
      <span
        style={{
          ...T.EYEBROW,
          fontSize: isMobile ? '10px' : '12px',
          color: SHELL_WHITE,
          textShadow: '0 1px 4px rgba(0,0,0,0.3)',
        }}
      >
        {eyebrow}
      </span>
      <span
        style={{
          ...T.DISPLAY,
          fontSize: isMobile ? '28px' : '36px',
          lineHeight: isMobile ? '36px' : '44px',
          color: SHELL_WHITE,
          marginTop: 14,
          maxWidth: 560,
          textShadow: '0 2px 8px rgba(0,0,0,0.4)',
        }}
      >
        {heading}
      </span>
      <Button
        tone="gradient"
        onClick={onGetStarted}
        style={{
          width: 'fit-content',
          borderRadius: 999,
          fontFamily: 'DM Sans',
          fontSize: isMobile ? 14 : 15,
          padding: isMobile ? '13px 26px' : '14px 32px',
          marginTop: isMobile ? 24 : 32,
        }}
      >
        Get started
      </Button>
    </div>
  );
};

export default CTABanner;
